// import React from 'react'

// const SettingsEmail = () => {
//   return (
//     <div style={{padding: "0px 0px 3px 0px"}}>SettingsEmail</div>
//   )
// }

// export default SettingsEmail

//  options={companySettings?.gsts?.map((gst: any) => ({
//                       key: gst.name,
//                       value: gst.id,
//                       title: gst.rate,
//                       label: gst.name,
//                     }))}

//  --------- setelect search value set searhc value in drop down -----------

// import React, { useState } from "react";
// import { Select } from "antd";
// import type { SelectProps } from "antd";
// import qs from "qs";
// import { useClient } from "../../Context/ClientContext";

// let timeout: ReturnType<typeof setTimeout> | null;
// let currentValue: string;

// const fetch = (
//   value: string,
//   callback: (data: { value: string; text: string }[]) => void
// ) => {
//   console.log("value", value);

//   if (timeout) {
//     clearTimeout(timeout);
//     timeout = null;
//   }
//   currentValue = value;

//   // const fake = () => {
//   //   const str = qs.stringify({
//   //     code: "utf-8",
//   //     q: value,
//   //   });
//   //   jsonp(`https://suggest.taobao.com/sug?${str}`)
//   //     .then((response: any) => response.json())
//   //     .then((d: any) => {
//   //       if (currentValue === value) {
//   //         const { result } = d;
//   //         const data = result.map((item: any) => ({
//   //           value: item[0],
//   //           text: item[0],
//   //         }));
//   //         callback(data);
//   //       }
//   //     });
//   // };
//   if (value) {
//     // timeout = setTimeout(fake, 300);
//   } else {
//     callback([]);
//   }
// };

// const SearchInput: React.FC<{
//   placeholder: string;
//   style: React.CSSProperties;
// }> = (props) => {
//   const [data, setData] = useState<SelectProps["options"]>([
//     { value: "jack", label: "Jack" },
//     { value: "lucy", label: "Lucy" },
//     { value: "Yiminghe", label: "yiminghe" },
//     { value: "disabled", label: "Disabled", disabled: true },
//   ]);
//   const [value, setValue] = useState<string>("");

//   const handleSearch = (newValue: string) => {
//     // fetch(newValue, setData);
//     setValue(newValue);
//   };

//   const handleChange = (newValue: string) => {
//     setValue(newValue);
//   };
//   const { companySettings } = useClient();

//   return (
//     <Select
//       // value={value}
//       searchValue={value}
//       placeholder={props.placeholder}
//       style={props.style}
//       suffixIcon={null}
//       onSearch={handleSearch}
//       onSelect={handleChange}
//       onChange={handleChange}
//       options={(data || []).map((d) => ({
//         value: d.value,
//         label: d.text,
//       }))}
//     />
//   );
// };

// const SettingsEmail: React.FC = () => {
//   const [data, setData] = useState<SelectProps["options"]>([
//     { value: "jack", label: "Jack" },
//     { value: "lucy", label: "Lucy" },
//     { value: "Yiminghe", label: "yiminghe" },
//     { value: "disabled", label: "Disabled", disabled: true },
//   ]);
//   const [value, setValue] = useState<string>("Not Identified");

//   // const handleSearch = (newValue: string) => {
//   //   // fetch(newValue, setData);
//   //   setValue(newValue);
//   // };

//   const handleChange = (newValue: any) => {
//     console.log(newValue);
//     setValue(newValue.label);
//   };
//   const { companySettings } = useClient();

//   return (
//     <Select
//       showSearch
//       style={{ width: "100px" }}
//       // value={value}
//       searchValue={value}
//       // searchValue={value}
//       suffixIcon={null}
//       labelInValue
//       onSearch={handleChange}
//       // onSelect={handleChange}
//       // onChange={handleChange}
//       placeholder="Search to Select"
//       optionFilterProp="label"
//       // filterSort={(optionA, optionB) =>
//       //   (optionA?.label ?? "")
//       //     .toLowerCase()
//       //     .localeCompare((optionB?.label ?? "").toLowerCase())
//       // }
//       options={[
//         {
//           value: "1",
//           label: "Not Identified",
//         },
//         {
//           value: "2",
//           label: "Closed",
//         },
//         {
//           value: "3",
//           label: "Communicated",
//         },
//         {
//           value: "4",
//           label: "Identified",
//         },
//         {
//           value: "5",
//           label: "Resolved",
//         },
//         {
//           value: "6",
//           label: "Cancelled",
//         },
//       ]}
//     />
//   );
// };

// export default SettingsEmail;

// auto call api in scroll drop down
// import React, { useEffect, useState } from "react";
// import { Select, Spin } from "antd";
// import ItemCategoryService from "../../Services/ItemCategoryService";
// import { useClient } from "../../Context/ClientContext";

// const { Option } = Select;

// const App = () => {
//   const [options, setOptions] = useState<any[]>([]);
//   const [loading, setLoading] = useState(false);
//   const { currentClient } = useClient();

//   const fetchCategories = async (start: number, limit: number) => {
//     setLoading(true);
//     try {
//       const res = await ItemCategoryService.getCategoryList(
//         currentClient?.id,
//         start,
//         limit
//       );
//       if (res?.result?.items?.length > 0) {
//         setOptions((prevOptions) => [...prevOptions, ...res.result.items]);
//       }
//     } catch (err: any) {
//       console.error("Error fetching categories:", err?.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     // Fetch initial data when component mounts
//     if (currentClient?.id) {
//       fetchCategories(0, 10);
//     }
//   }, [currentClient?.id]);

//   const handlePopupScroll = (e: any) => {
//     const { target } = e;
//     // Check if the user has scrolled to the bottom
//     console.log(
//       "target",
//       target.scrollTop,
//       target.offsetHeight,
//       target.scrollHeight,
//       e
//     );

//     if (
//       // target.scrollTop + target.offsetHeight === target.scrollHeight &&
//       options.length < 50
//     ) {
//       fetchCategories(options.length, 15);
//     }
//   };

//   return (
//     <Select
//       showSearch
//       placeholder="Select an item"
//       style={{ width: 300 }}
//       onPopupScroll={handlePopupScroll}
//       dropdownRender={(menu) => (
//         <>
//           {menu}
//           {loading && (
//             <div style={{ textAlign: "center", padding: 8 }}>
//               <Spin size="small" />
//             </div>
//           )}
//         </>
//       )}
//     >
//       {options.map((item) => (
//         <Option key={item.id} value={item.categoryName}>
//           {item.categoryName}
//         </Option>
//       ))}
//     </Select>
//   );
// };

// export default App;

import React from "react";
import { Col, Row, Select } from "antd";
import { useClient } from "../../Context/ClientContext";
import ItemsService, { CAPItemTypes } from "../../Services/ItemsService";

const App: React.FC = () => {
  const [itemsOption, setItemsOption] = React.useState<any[]>([]);
  const { currentClient } = useClient();

  React.useEffect(() => {
    const items = async () => {
      await ItemsService.searchItem(
        currentClient?.id!,
        "",
        CAPItemTypes.Purchase
      )
        .then((res: any) => {
          const x = res.map((itm: any) => {
            return {
              label: itm?.name,
              value: itm?.value,
              hsnCode: itm?.hsnCode,
              sacCode: itm?.sacCode,
              description: itm?.description,
              barCode: itm?.barCode,
            };
          });
          setItemsOption(x);
        })
        .catch((err: any) => {
          console.log("error", err);
        });
    };
    items();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  // name
  // hsnCode
  // sacCode
  // description

  return (
    <Select
      showSearch
      style={{ width: 200 }}
      placeholder="Search items"
      options={itemsOption}
      optionRender={(option) => (
        <div aria-label={option.data?.label}>
          <Row justify={"space-between"}>
            <Col>
              <p
                style={{
                  fontWeight: "bold",
                  color: "dimgray",
                }}
              >
                {option.data?.label}
              </p>
            </Col>
          </Row>
          <div>
            {option.data?.hsnCode && (
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "dimgray",
                  }}
                >
                  HSN Code -
                </span>
                {option.data?.hsnCode}
              </span>
            )}
            {option.data?.sacCode && (
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "dimgray",
                  }}
                >
                  SAC Code -
                </span>
                {option.data?.sacCode}
              </span>
            )}
            {option.data?.description && (
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "dimgray",
                  }}
                >
                  Des. -
                </span>
                {option.data?.description}
              </span>
            )}
          </div>
        </div>
      )}
      filterOption={(input, option: any) => {
        const query = input.toLowerCase();

        // Precompute a Map for barCode lookup based on id (or value)
        const barCodeMap = new Map(
          itemsOption.map((item) => [item?.label, item?.barCode?.toLowerCase()])
        );

        console.log(
          "barCodeMap",
          barCodeMap
          // itemsOption.map((item) => [item?.label, item?.barCode?.toLowerCase()])
        );

        // Safely handle label
        const label = (option?.label ?? "").toLowerCase();

        const barCode = barCodeMap.get(option?.label) ?? "";

        console.log("barCode", barCode);

        // Check for exact match
        if (barCode === query || label === query) {
          return label.includes(query) || barCode.includes(query);
        }

        // console.log("option",input, option);

        console.log(option?.label);

        // Check for partial matches
        return label.includes(query) || barCode.includes(query);
        // || barCode.includes(query);
      }}
    />
  );
};

export default App;
